"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactionTypeEnum = void 0;
var ReactionTypeEnum;
(function (ReactionTypeEnum) {
    ReactionTypeEnum["DEFAULT"] = "default";
    ReactionTypeEnum["ASSIGN_AT"] = "assignAt";
    ReactionTypeEnum["SELECT_MENU"] = "selectMenu";
})(ReactionTypeEnum || (exports.ReactionTypeEnum = ReactionTypeEnum = {}));
